import { useForm } from 'react-hook-form';
import { Merchant } from '../../../domain/merchant';

interface BranchDetailForm {
  id: string;
  fantasy_name: string;
  merchant_info: Merchant;
  description: string;
  address_state: string;
  address_city: string;
  address_street: string;
  address_number: string;
  address_apartment: string;
  address_floor: string;
  address_zip: string;
  phone: string;
  email: string;
  account_alias: string;
  cbu_or_cvu: string;
  identifier: number;
}

export const useBranchDetailForm = () => {
  const { reset, register } = useForm<BranchDetailForm>();

  return {
    controls: {
      id: register('id'),
      fantasy_name: register('fantasy_name'),
      business_name: register('merchant_info.business_name'),
      description: register('description'),
      address_state: register('address_state'),
      address_city: register('address_city'),
      address_street: register('address_street'),
      address_number: register('address_number'),
      address_apartment: register('address_apartment'),
      address_floor: register('address_floor'),
      address_zip: register('address_zip'),
      phone: register('phone'),
      email: register('email'),
      account_alias: register('account_alias'),
      cbu_or_cvu: register('cbu_or_cvu'),
      identifier: register('identifier'),
    },
    reset,
  };
};
